module.exports = __webpack_public_path__ + "img/tooltip-girl-2.f133ce9a.png";